<template>
  <div class="app-container">
    <div class="top">
      <div class="left">收</div>
      <div class="right">
        <p>{{ msg.receive_name }}</p>
        <p>{{ msg.receive_mobile }}</p>
        <p>{{ msg.province }}{{ msg.city }}{{ msg.area }}{{ msg.address }}</p>
      </div>
    </div>
    <div class="msg">
      <h3>订单信息</h3>
      <p>
        <span>订单编号:</span><span>{{ msg.order_sn }}</span>
      </p>
      <p>
        <span>下单日期:</span><span>{{ msg.pay_time }}</span>
      </p>
      <p v-for="item in msg.goods">
        <span>商品名称:</span><span>{{ item.goods_name }}</span
        ><span>规格:</span><span>{{ item.goods_attr }}</span
        ><span>数量:</span><span>{{ item.goods_number }}</span>
      </p>
      <p>
        <span>付款方式:</span><span>{{ ["", "支付宝", "微信", "对公打款", "线下支付", "免费"][msg.pay_type] }}</span>
      </p>
      <h3>
        <span>合计:</span><span>￥{{ msg.order_amount }}</span>
      </h3>
    </div>
    <div class="progress">
      <h3>物流进度</h3>
      <el-timeline :reverse="reverse">
        <el-timeline-item v-for="(item, index) in msg.transport" :key="index" :timestamp="item.ftime">
          {{ item.status }} : {{ item.context }}
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { GoodsOrderDetail } from "@/api/order.js";
export default {
  data() {
    return {
      msg: {
        name: "mmc",
        phone: "12131",
        address: "中国",
        ordercode: "211",
        data: "2021",
        product: "商品",
        model: "全集",
        price: "200",
        num: 1,
        payType: "微信",
        total: 200,
      },
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
    };
  },
  mounted() {
    this.querys = this.$route.query;
    if (this.querys.order_id) {
      this.getDetail(this.querys.order_id);
    } else {
      this.$message.error("未识别的订单");
    }
  },
  methods: {
    async getDetail(id) {
      const res = await GoodsOrderDetail(id);
      if (res) {
        this.msg = res;
      } else {
        this.msg = this.$route.query;
      }
      console.log(res);
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.top {
  display: flex;
  align-items: center;

  padding-bottom: 20px;
  border-bottom: 1px solid #bbb;
  .left {
    background-color: red;
    color: white;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
  }
}
.msg {
  span {
    margin-right: 10px;
  }
}
.progress {
  h3 {
    margin-top: 30px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
}
</style>
